import React from "react";
import Home from "views/Home";
import Representatives from "views/representatives";
import DistrictRepresentatives from "views/representatives/district";
import Projects from "views/projects";
import PartyAffiliation from "views/party";
import ProjectComponent from "views/projects/detail";
import ProjectProgram from "views/projects/detail/program";
import PartyComponent from "views/party/detail";
import CongressRepresentative from "views/representatives/congressman";
import AddProject from "views/projects/add";
import AccountList from "views/accounts/list";
import Account from "views/accounts/detail";
import SummaryExport from "views/summary/export";
import Directory from "views/directory";
import CongressmanDetails from "views/directory/congressman";
import AgencyComponent from "views/directory/agency";
import DirectorDetails from "views/directory/director";
import GovernorDetails from "views/directory/governor";
import ViceGovernorDetails from "views/directory/viceGovernor";
import SenatorDetails from "views/directory/senator";
import MayorDetails from "views/directory/mayor";
import ViceMayorDetails from "views/directory/viceMayor";
import OthersDetails from "views/directory/others";
import { getUserDetails } from "config";
import { hasPermission } from "utility/helpers";
import RecipientDetails from "views/projects/form";
import {
  ACCOUNTS_VIEW,
  COMMITTEE_VIEW,
  DIRECTORY_VIEW,
  HIDDEN_AFFILIATIONS_VIEW,
  HIDDEN_PROGRAMS_VIEW,
  HIDDEN_REPRESENTATIVES_VIEW,
} from "utility/constants";
import NewsAndAnnouncement from "views/news";
import AddAnnouncement from "views/news/add";
import NotificationsLogs from "views/logs";
import UtilizationReport from "views/utilization";
import AddUtilization from "views/utilization/add";
import NationalAgenciesComponent from "views/directory/nationalAgencies";
import TVISettings from "views/settings/tesda";
import Events from "views/events";
import AddEvent from "views/events/add";
import EventDetails from "views/events/detail";
import ViewCongressmanEvent from "views/events/congressman";
import RepresentativeEvents from "views/representatives/events";
import AddEndorsement from "views/settings/tesda/endorsements/add";
import AddTvi from "views/settings/tesda/settings/add";
import AddCourse from "views/settings/tesda/courses/add";
import Committee from "views/committee";
import Others from "views/dpwhlisting";

const role = getUserDetails()?.type;

export const privateRoutes = [
  {
    exact: true,
    path: "/",
    element: <Home />,
    HasPermission: hasPermission("landing"),
  },
  {
    exact: true,
    path: "/home",
    element: <Home />,
    HasPermission: hasPermission("landing"),
  },
  {
    exact: true,
    path: "/representatives",
    element: <Representatives />,
    HasPermission: !HIDDEN_REPRESENTATIVES_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/representatives/:id",
    element: <DistrictRepresentatives />,
    HasPermission: !HIDDEN_REPRESENTATIVES_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/representatives/:id/cong/:congID",
    element: <CongressRepresentative />,
    HasPermission: hasPermission("congressman-view"),
  },
  {
    exact: true,
    path: "/projects",
    element: <Projects />,
    HasPermission: !HIDDEN_PROGRAMS_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/projects/:id",
    element: <ProjectComponent />,
    HasPermission: !HIDDEN_PROGRAMS_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/projects/:id/program/:programID",
    element: <ProjectProgram />,
    HasPermission: !HIDDEN_PROGRAMS_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/parties",
    element: <PartyAffiliation />,
    HasPermission: !HIDDEN_AFFILIATIONS_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/parties/:id",
    element: <PartyComponent />,
    HasPermission: !HIDDEN_AFFILIATIONS_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/add-project",
    element: <AddProject />,
    HasPermission: hasPermission("project-create"),
  },
  {
    exact: true,
    path: "/accounts",
    element: <AccountList />,
    HasPermission: ACCOUNTS_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/add-account",
    element: <Account />,
    HasPermission: hasPermission("user-create"),
  },
  {
    exact: true,
    path: "/account",
    element: <Account />,
    HasPermission: hasPermission("user-update"),
  },
  {
    exact: true,
    path: "/summary",
    element: <SummaryExport />,
    HasPermission:
      hasPermission("summary-view") || hasPermission("summary-daily-view"),
  },
  {
    exact: true,
    path: "/utilization",
    element: <UtilizationReport />,
    HasPermission: hasPermission("utilization-view"),
  },
  {
    exact: true,
    path: "/utilization/add",
    element: <AddUtilization />,
    HasPermission: hasPermission("utilization-create"),
  },
  {
    exact: true,
    path: "/utilization/edit",
    element: <AddUtilization />,
    HasPermission: hasPermission("utilization-update"),
  },
  {
    exact: true,
    path: "/utilization/view",
    element: <AddUtilization />,
    HasPermission: hasPermission("utilization-view"),
  },
  {
    exact: true,
    path: "/directory/:view",
    element: <Directory />,
    HasPermission: DIRECTORY_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/directory",
    element: <Directory />,
    HasPermission: DIRECTORY_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/cong",
    element: <CongressmanDetails />,
    HasPermission: hasPermission("congressman-update"),
  },
  {
    exact: true,
    path: "/agency",
    element: <AgencyComponent />,
    HasPermission: hasPermission("user-create"),
  },
  {
    exact: true,
    path: "/director",
    element: <DirectorDetails />,
    HasPermission: hasPermission("regional-director-create"),
  },
  {
    exact: true,
    path: "/gov",
    element: <GovernorDetails />,
    HasPermission: hasPermission("official-update"),
  },
  {
    exact: true,
    path: "/vicegov",
    element: <ViceGovernorDetails />,
    HasPermission: hasPermission("official-update"),
  },
  {
    exact: true,
    path: "/sen",
    element: <SenatorDetails />,
    HasPermission: hasPermission("official-update"),
  },
  {
    exact: true,
    path: "/mayor",
    element: <MayorDetails />,
    HasPermission: hasPermission("official-update"),
  },
  {
    exact: true,
    path: "/vicemayor",
    element: <ViceMayorDetails />,
    HasPermission: hasPermission("official-update"),
  },
  {
    exact: true,
    path: "/others",
    element: <OthersDetails />,
    HasPermission: hasPermission("official-update"),
  },
  {
    exact: true,
    path: "/projects/:id/program/:programID/recipient",
    element: <RecipientDetails />,
    HasPermission: hasPermission("recipient-update"),
  },
  {
    exact: true,
    path: "/representatives/:id/cong/:congID/recipient",
    element: <RecipientDetails />,
    HasPermission: hasPermission("recipient-update"),
  },
  {
    exact: true,
    path: "/news",
    element: <NewsAndAnnouncement />,
    HasPermission: hasPermission("news-view"),
  },
  {
    exact: true,
    path: "/news/add",
    element: <AddAnnouncement />,
    HasPermission: hasPermission("news-create"),
  },
  {
    exact: true,
    path: "/news/edit",
    element: <AddAnnouncement />,
    HasPermission: hasPermission("news-update"),
  },
  {
    exact: true,
    path: "/news/view",
    element: <AddAnnouncement />,
    HasPermission: hasPermission("news-view"),
  },
  {
    exact: true,
    path: "/logs",
    element: <NotificationsLogs />,
    HasPermission: hasPermission("logs-view"),
  },
  {
    exact: true,
    path: "/national",
    element: <NationalAgenciesComponent />,
    HasPermission: hasPermission("national-agency-user-view"),
  },
  {
    exact: true,
    path: "/events",
    element: <Events />,
    HasPermission: hasPermission("event-view"),
  },
  {
    exact: true,
    path: "/events/add",
    element: <AddEvent />,
    HasPermission: hasPermission("event-create"),
  },
  {
    exact: true,
    path: "/events/edit",
    element: <AddEvent />,
    HasPermission: hasPermission("event-update"),
  },
  {
    exact: true,
    path: "/events/view",
    element: <AddEvent />,
    HasPermission: hasPermission("event-view"),
  },
  {
    exact: true,
    path: "/events/:id/details",
    element: <EventDetails />,
    HasPermission: hasPermission("event-view"),
  },
  {
    exact: true,
    path: "/events/congressman/:id/events",
    element: <ViewCongressmanEvent />,
    HasPermission: hasPermission("event-view"),
  },
  {
    exact: true,
    path: "/representatives/:id/cong/:congID/event",
    element: <RepresentativeEvents />,
    HasPermission: hasPermission("event-view"),
  },
  {
    path: "/settings/tesda",
    element: <TVISettings />,
    HasPermission: hasPermission("tvi-view"),
  },
  {
    exact: true,
    path: "/settings/tesda/endorsements",
    element: <TVISettings />,
    HasPermission: hasPermission("tvi-view"),
  },
  {
    exact: true,
    path: "/settings/tesda/endorsements/add",
    element: <AddEndorsement />,
    HasPermission: hasPermission("tvi-create"),
  },
  {
    exact: true,
    path: "/settings/tesda/endorsements/:id",
    element: <AddEndorsement />,
    HasPermission: hasPermission("tvi-view"),
  },
  {
    exact: true,
    path: "/settings/tesda/tvi",
    element: <TVISettings />,
    HasPermission: hasPermission("tvi-view"),
  },
  {
    exact: true,
    path: "/settings/tesda/tvi/:id",
    element: <TVISettings />,
    HasPermission: hasPermission("tvi-view"),
  },
  {
    exact: true,
    path: "/settings/tesda/tvi/add",
    element: <AddTvi />,
    HasPermission: hasPermission("tvi-create"),
  },
  {
    exact: true,
    path: "/settings/tesda/tvi/:id/edit",
    element: <AddTvi />,
    HasPermission: hasPermission("tvi-update"),
  },
  {
    exact: true,
    path: "/settings/tesda/courses",
    element: <TVISettings />,
    HasPermission: hasPermission("tvi-view"),
  },
  {
    exact: true,
    path: "/settings/tesda/courses/:id",
    element: <TVISettings />,
    HasPermission: hasPermission("tvi-view"),
  },
  {
    exact: true,
    path: "settings/tesda/courses/add",
    element: <AddCourse />,
    HasPermission: hasPermission("tvi-create"),
  },
  {
    exact: true,
    path: "settings/tesda/courses/:id/edit",
    element: <AddCourse />,
    HasPermission: hasPermission("tvi-update"),
  },
  {
    exact: true,
    path: "/committee",
    element: <Committee />,
    HasPermission: COMMITTEE_VIEW.includes(role),
  },
  {
    exact: true,
    path: "/dpwhlisting",
    element: <Others />,
    HasPermission: hasPermission("others-view"),
  },
];
